export default __webpack_public_path__ + "static/media/picker-logo-op.fb39e0fa.svg";